// extracted by mini-css-extract-plugin
export default {"navHost":"nav-host-provider_navHost__e0baG","backBtn":"nav-host-provider_backBtn__VYl4j"};